'use strict';

var request = require('superagent');

var JsonRpc = function JsonRpc(endpoint, namespace) {
	this.endpoint = endpoint;
	this.namespace = namespace;
};

JsonRpc.prototype.call = function (method, args, callback) {
	var jsonRequest = this.buildRequest(method, { params: args });
	request.post(this.endpoint).type('application/json').send(jsonRequest).end(function (err, res) {
		try {
			var response = JSON.parse(res.text);
			if (response.error) {
				callback(response.error, null);
			} else {
				callback(null, response.result);
			}
		} catch (e) {
			callback(res.text, null);
		}
	});
};

JsonRpc.prototype.buildRequest = function (method, options) {
	if (options === undefined) {
		options = { id: 1 };
	}
	if (options.id === undefined) {
		options.id = 1;
	}
	// Validate method arguments
	//this._validateRequestMethod(method);
	//this._validateRequestParams(options.params);
	//this._validateRequestCallbacks(options.success, options.error);
	var dataObj = {
		jsonrpc: '2.0',
		method: this.namespace ? this.namespace + '.' + method : method,
		id: options.id
	};
	if (options.params !== undefined) {
		dataObj.params = options.params;
		/*Object.keys(dataObj.params).forEach((key) => {
  	console.log(key);
  	console.log(dataObj.params[key]);
  	if (typeof dataObj.params[key] == 'undefined') {
  		dataObj.params[key] = 1;
  	}
  });*/
	}
	return dataObj;
};

module.exports = JsonRpc;


/*****************
 ** WEBPACK FOOTER
 ** ./src/transport/jsonrpc.js
 ** module id = 1062
 ** module chunks = 2
 **/